import {createSelector} from "reselect";

const groups = (state) => state.group;

export const getGroupObj = createSelector(groups, (groups) => groups.groupListData || {});

export const getGroupsList = createSelector(getGroupObj, (group) => group?.results || []);
export const getGroupLabelValue = createSelector(
  groups,
  (groups) => groups?.groupLabelValue || []
);

export const getGroupsTotalCount = createSelector(
  getGroupObj,
  (group) => group?.total_count
);

export const getGroupsginationUrls = createSelector(getGroupObj, (logs) => ({
  prevUrl: logs?.previous,
  nextUrl: logs?.next,
}));

export const getPermissionList = createSelector(
  groups,
  (groups) => groups.permissions_list || []
);

export const getGroupModalStatus = createSelector(
  groups,
  (groups) => groups.groupModalStatus
);

export const getUsersList = createSelector(groups, (groups) => groups.users_list || []);
